var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1237 13.452V2.56799H12.8757V13.452L17.3877 8.93999L18.6237 10.176L14.0397 14.76C12.9117 15.888 11.0997 15.888 9.9717 14.76L5.3877 10.176L6.6237 8.93999L11.1357 13.452H11.1237ZM17.9997 21.444H5.9997V19.692H17.9997V21.444Z","fill":"black"}));
}

Download.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","className":"icon"};

module.exports = Download;

Download.default = Download;
